/* Kit owns submission, validation, confirmation and bot protection. No API keys. */
(() => {
  'use strict';
  if (window.CMGifts) { window.CMGifts.init(document); return; }
  const KEY = 'cm_gifts_v1';
  let memory = {};
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (_) { return memory; } };
  const write = patch => { memory = { ...read(), ...patch }; try { localStorage.setItem(KEY, JSON.stringify(memory)); } catch (_) {} };
  const editing = () => Boolean(window.Shopify && window.Shopify.designMode);
  const track = (event, source) => {
    // No analytics until Shopify's Customer Privacy API explicitly permits it.
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({event, cm_placement: source});
  };
  const accepted = source => {
    write({submittedUntil: Date.now() + 30 * 86400000});
    track('cm_optin_request_accepted', source); // Not a confirmed subscriber conversion.
    document.dispatchEvent(new CustomEvent('cm:gifts:accepted'));
  };
  const visible = el => Boolean(el && el.textContent.trim() && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).display !== 'none');
  function loadKit(mount) {
    if (mount.dataset.cmReady) return;
    mount.dataset.cmReady = 'true';
    const rawURL = mount.dataset.script || '', uid = mount.dataset.uid || '';
    const fallback = mount.querySelector('[data-cm-fallback]');
    let url;
    try {
      url = new URL(rawURL);
      if (url.protocol !== 'https:' || !/(^|\.)(kit\.com|convertkit\.com|ck\.page)$/.test(url.hostname) || !/^[a-zA-Z0-9_-]+$/.test(uid)) throw new Error('Invalid Kit embed settings');
    } catch (_) { if (fallback) fallback.hidden = false; return; }
    const host = mount.querySelector('[data-cm-kit-host]');
    if (!host) return;
    let didAccept = false;
    const observer = new MutationObserver(() => {
      // Wait for Kit's success UI. Never infer success from a button click or HTTP attempt.
      if (!didAccept && [...host.querySelectorAll('.formkit-alert-success')].some(visible)) {
        didAccept = true; accepted(mount.dataset.source || 'unknown');
        if (fallback) fallback.hidden = true;
      }
    });
    observer.observe(host, {childList:true, subtree:true, attributes:true, characterData:true});
    mount.cmObserver = observer;
    const script = document.createElement('script');
    script.async = true; script.dataset.uid = uid; script.src = url.href;
    script.onerror = () => { if (fallback) fallback.hidden = false; };
    host.appendChild(script);
    mount.cmTimer = setTimeout(() => { if (fallback && !host.querySelector('form')) fallback.hidden = false; }, 10000);
  }
  function initPopup(dialog) {
    if (dialog.dataset.cmReady) return;
    dialog.dataset.cmReady = 'true';
    const scope = dialog.dataset.scope || 'home_product';
    const page = dialog.dataset.page || '';
    const blocked = dialog.dataset.blocked === 'true';
    const state = read(), now = Date.now();
    const autoAllowed = !editing() && !blocked && (scope === 'all' || ['index','product'].includes(page)) && !(state.dismissedUntil > now || state.submittedUntil > now || state.confirmedUntil > now || state.seenUntil > now);
    let oldFocus = null, oldOverflow = '', timer;
    const open = () => {
      if (!dialog.isConnected || dialog.open || document.querySelector('dialog[open], cart-drawer.active, menu-drawer details[open], details-modal details[open]')) return;
      if (!editing() && (document.visibilityState !== 'visible' || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || ''))) return;
      if (typeof dialog.showModal !== 'function') return;
      oldFocus = document.activeElement; oldOverflow = document.body.style.overflow;
      dialog.showModal(); document.body.style.overflow = 'hidden';
      if (!editing()) { write({seenUntil:Date.now() + 86400000}); track('cm_optin_popup_view', 'popup'); }
      dialog.querySelector('[data-cm-close]')?.focus();
    };
    const dismiss = () => {
      if (!dialog.open) return;
      write({dismissedUntil:Date.now() + Number(dialog.dataset.cooldown || 7) * 86400000});
      dialog.close();
    };
    dialog.querySelectorAll('[data-cm-close]').forEach(b => b.addEventListener('click', dismiss));
    dialog.addEventListener('cancel', e => { e.preventDefault(); dismiss(); });
    dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) dismiss(); } });
    dialog.addEventListener('close', () => { document.body.style.overflow = oldOverflow; if (oldFocus?.isConnected) oldFocus.focus(); });
    // Explicit keyboard wrap, in addition to the native modal dialog's inert background.
    dialog.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const items = [...dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    const stop = () => clearTimeout(timer);
    document.addEventListener('cm:gifts:accepted', stop);
    if (autoAllowed) timer = setTimeout(open, Number(dialog.dataset.delay || 12) * 1000);
    const manual = e => { if (e.target.closest('[data-cm-open-popup]')) { e.preventDefault(); open(); } };
    document.addEventListener('click', manual);
    dialog.cmCleanup = () => { stop(); if (dialog.open) dialog.close(); document.removeEventListener('click',manual); document.removeEventListener('cm:gifts:accepted',stop); };
  }
  function init(root) {
    root.querySelectorAll('[data-cm-kit]').forEach(loadKit);
    root.querySelectorAll('dialog[data-cm-popup]').forEach(initPopup);
    if (root.querySelector('[data-cm-inbox]')) write({submittedUntil:Date.now() + 30 * 86400000});
    if (root.querySelector('[data-cm-confirmed]')) write({confirmedUntil:Date.now() + 365 * 86400000});
  }
  window.CMGifts = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-cm-kit]').forEach(m => { m.cmObserver?.disconnect(); clearTimeout(m.cmTimer); });
    e.target.querySelectorAll('[data-cm-popup]').forEach(d => d.cmCleanup?.());
  });
})();
